import { message } from "antd";

/**
 * Every Group Console create call can partially fail — one branch's
 * duplicate-name conflict or a DB hiccup shouldn't hide that the others went
 * through. Shared by every create modal so the messaging reads the same way
 * everywhere.
 */
export default function reportCreateResult(result, label) {
  const created = result?.created?.length || 0;
  const errors = result?.errors || [];

  if (created) {
    message.success(
      `${label} created in ${created} branch${created > 1 ? "es" : ""}`,
    );
  }
  if (errors.length) {
    message.warning(
      `Failed in ${errors.length} branch${errors.length > 1 ? "es" : ""}: ${errors
        .map((e) => `${e.school_name} (${e.message || "error"})`)
        .join(", ")}`,
    );
  }
}
